import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ServiceCard from './ServiceCard';
import './ServicesOverview.css';
import webImage from '../assets/foto_web.webp';
import kiImage from '../assets/team-office.webp';
import mobileImage from '../assets/mobile_2.webp';
import dataImage from '../assets/office-multi-hero.webp';

function ServicesOverview() {
  const { t } = useTranslation();
  const servicesData = t('services_overview.services', { returnObjects: true });

  const images = [
    webImage,
    kiImage,
    mobileImage,
    dataImage
  ];

  const categories = [
    "Web Development",
    "Automation",
    "Mobile Development",
    "Data Intelligence"
  ];

  return (
    <section className="services-overview">
      <div className="services-overview-container">
        <div className="services-header">
          <h2>{t('services_overview.title')}</h2>
        </div>

        <div className="service-cards-grid">
          {servicesData.map((service, index) => (
            <Link to={`/leistungen/${index + 1}`} key={index} className="service-card-link">
              <ServiceCard
                title={service.title}
                category={categories[index] || "Service"}
                image={images[index]}
                className={`service-card-${service.id}`}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesOverview;